import React, {useContext, useEffect, useState} from "react";
import useConsumer from "../channels/consumer";
import {AppContext} from "../contexts/AppContext";
import {SessionContext} from "../contexts/SessionContext";

export default () => {
    const {state} = useContext(AppContext);
    const {state: sessionState} = useContext(SessionContext);
    const consumer = useConsumer();
    const [status, setStatus] = useState({});
    
    useEffect(() => {
        const interval = setInterval(() => {
            if (consumer) {
                const subscriptions = consumer.subscriptions?.subscriptions || [];
                const status = {
                    connectionActive: consumer.connection?.isActive(),
                    connectionState: consumer.connection?.getState?.(),
                    webSocketState: consumer.connection?.webSocket?.readyState,
                    subscriptionCount: subscriptions.length,
                    subscriptions: subscriptions.map(s => {
                        try {
                            const identifier = JSON.parse(s.identifier);
                            return identifier.channel;
                        } catch {
                            return s.identifier;
                        }
                    }),
                    userId: state.currentUser?.id,
                    orgId: sessionState.currentOrg?.id
                };
                setStatus(status);
                
                // Log to console for debugging
                console.log('🔍 ActionCable Debug:', status);
            }
        }, 2000);
        
        return () => clearInterval(interval);
    }, [consumer, state.currentUser, sessionState.currentOrg]);
    
    return (
        <div style={{
            position: 'fixed',
            bottom: 10,
            right: 10,
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: 10,
            borderRadius: 5,
            fontSize: 12,
            fontFamily: 'monospace',
            zIndex: 10000
        }}>
            <div>Connection: {status.connectionActive ? '✅' : '❌'} ({status.connectionState})</div>
            <div>WebSocket: {['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'][status.webSocketState] || 'UNKNOWN'}</div>
            <div>Subscriptions: {status.subscriptionCount}</div>
            <div>Channels: {(status.subscriptions || []).join(', ')}</div>
            <div>User: {status.userId || 'none'} | Org: {status.orgId || 'none'}</div>
        </div>
    );
}